import {
    URL_PARAMETER_DOCUMENT,
    URL_PARAMETER_FV_DOCUMENT_PATH,
    URL_PARAMETER_PATH,
    URL_PARAMETER_TEMPLATE_NAME,
} from '../../../constants/url.parameter.names';
import { failure } from './commandResult';
import { UNEXPECTED_ERROR } from './errorHandling';

const excludeQueryParts = [
    URL_PARAMETER_TEMPLATE_NAME,
    URL_PARAMETER_DOCUMENT,
    URL_PARAMETER_PATH,
    URL_PARAMETER_FV_DOCUMENT_PATH,
].map((s) => s.toLowerCase());

const getQueryParts = (loc) =>
    loc.search
        .replace(/^\?/, '')
        .split('&')
        .map((kvs) => kvs.split('=').map(decodeURIComponent))
        .map((kvp) => ({ key: kvp[0], value: kvp[1] || '' }));

export const getNetworkFileDownloadPath = (path, environment) => {
    const location = environment.getCurrentLocation();

    const beforeQueryPath = `${location.protocol}//${location.host}/LocalProxy/File`;

    const query = getQueryParts(location)
        .filter((kv) => excludeQueryParts.indexOf(kv.key.toLowerCase()) === -1)
        .concat([{ key: URL_PARAMETER_PATH, value: path }])
        .map(
            (kv) =>
                `${encodeURIComponent(kv.key)}=${encodeURIComponent(kv.value)}`,
        )
        .join('&');

    return `${beforeQueryPath}?${query}`;
};

function handleAccessCheckResult(result) {
    const isSuccess = result?.success;
    const errorMessage = result?.error?.Message;

    if (!isSuccess) {
        return failure(errorMessage || UNEXPECTED_ERROR);
    }

    return null;
}

function handleAccessCheckError(error) {
    const message = error?.responseJSON?.ErrorMessage;

    return failure(message || UNEXPECTED_ERROR);
}

// (QfsApi, String) -> CommandResult
export const performLocalAccessCheck = async (api, path) => {
    try {
        const result = await api.localNetworkUsageCheckAsync(path);

        return handleAccessCheckResult(result);
    } catch (error) {
        return handleAccessCheckError(error);
    }
};
